/**
 * @license
 * Copyright Google Inc. All Rights Reserved.
 *
 * Use of this source code is governed by an MIT-style license that can be
 * found in the LICENSE file at https://angular.io/license
 */


import {
  Component,
  ViewEncapsulation,
  Renderer2,
  ElementRef,
  Input,
  ContentChildren,
  QueryList,
  AfterContentInit,
  Directive,
  ChangeDetectionStrategy,
} from '@angular/core';
import {MdLine, MdLineSetter} from '@angular/material/core';
import {coerceToNumber} from './grid-list-measure';
export class MdGridTile {
  _rowspan: number = 1;
  _colspan: number = 1;
/**
 * @param {?} _renderer
 * @param {?} _element
 */
constructor(private _renderer: Renderer2,
private _element: ElementRef) {}
/**
 * Amount of rows that the grid tile takes up.
 * @return {?}
 */
get rowspan() { return this._rowspan; }
/**
 * @param {?} value
 * @return {?}
 */
set rowspan(value) { this._rowspan = coerceToNumber(value); }
/**
 * Amount of columns that the grid tile takes up.
 * @return {?}
 */
get colspan() { return this._colspan; }
/**
 * @param {?} value
 * @return {?}
 */
set colspan(value) { this._colspan = coerceToNumber(value); }
/**
 * Sets the style of the grid-tile element.  Needs to be set manually to avoid
 * "Changed after checked" errors that would occur with HostBinding.
 * @param {?} property
 * @param {?} value
 * @return {?}
 */
_setStyle(property: string, value: any): void {
    this._renderer.setStyle(this._element.nativeElement, property, value);
  }
static decorators: DecoratorInvocation[] = [
{ type: Component, args: [{
  moduleId: module.id,
  selector: 'md-grid-tile, mat-grid-tile',
  host: {
    'class': 'mat-grid-tile',
  },
  templateUrl: 'grid-tile.html',
  styleUrls: ['grid-list.css'],
  encapsulation: ViewEncapsulation.None,
  preserveWhitespaces: false,
  changeDetection: ChangeDetectionStrategy.OnPush,
}, ] },
];
/**
 * @nocollapse
 */
static ctorParameters: () => ({type: any, decorators?: DecoratorInvocation[]}|null)[] = () => [
{type: Renderer2, },
{type: ElementRef, },
];
static propDecorators: {[key: string]: DecoratorInvocation[]} = {
'rowspan': [{ type: Input },],
'colspan': [{ type: Input },],
};
}

function MdGridTile_tsickle_Closure_declarations() {
/** @type {?} */
MdGridTile.decorators;
/**
 * @nocollapse
 * @type {?}
 */
MdGridTile.ctorParameters;
/** @type {?} */
MdGridTile.propDecorators;
/** @type {?} */
MdGridTile.prototype._rowspan;
/** @type {?} */
MdGridTile.prototype._colspan;
/** @type {?} */
MdGridTile.prototype._renderer;
/** @type {?} */
MdGridTile.prototype._element;
}

export class MdGridTileText implements AfterContentInit {
/**
 *  Helper that watches the number of lines in a text area and sets
 * a class on the host element that matches the line count.
 */
_lineSetter: MdLineSetter;
   _lines: QueryList<MdLine>;
/**
 * @param {?} _renderer
 * @param {?} _element
 */
constructor(private _renderer: Renderer2,
private _element: ElementRef) {}
/**
 * @return {?}
 */
ngAfterContentInit() {
    this._lineSetter = new MdLineSetter(this._lines, this._renderer, this._element);
  }
static decorators: DecoratorInvocation[] = [
{ type: Component, args: [{
  moduleId: module.id,
  selector: 'md-grid-tile-header, mat-grid-tile-header, md-grid-tile-footer, mat-grid-tile-footer',
  templateUrl: 'grid-tile-text.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
  encapsulation: ViewEncapsulation.None,
  preserveWhitespaces: false,
}, ] },
];
/**
 * @nocollapse
 */
static ctorParameters: () => ({type: any, decorators?: DecoratorInvocation[]}|null)[] = () => [
{type: Renderer2, },
{type: ElementRef, },
];
static propDecorators: {[key: string]: DecoratorInvocation[]} = {
'_lines': [{ type: ContentChildren, args: [MdLine, ] },],
};
}

function MdGridTileText_tsickle_Closure_declarations() {
/** @type {?} */
MdGridTileText.decorators;
/**
 * @nocollapse
 * @type {?}
 */
MdGridTileText.ctorParameters;
/** @type {?} */
MdGridTileText.propDecorators;
/**
 *  Helper that watches the number of lines in a text area and sets
 * a class on the host element that matches the line count.
 * @type {?}
 */
MdGridTileText.prototype._lineSetter;
/** @type {?} */
MdGridTileText.prototype._lines;
/** @type {?} */
MdGridTileText.prototype._renderer;
/** @type {?} */
MdGridTileText.prototype._element;
}

/**
 * Directive whose purpose is to add the mat- CSS styling to this selector.
 * \@docs-private
 */
export class MdGridAvatarCssMatStyler {static decorators: DecoratorInvocation[] = [
{ type: Directive, args: [{
  selector: '[md-grid-avatar], [mat-grid-avatar], [mdGridAvatar], [matGridAvatar]',
  host: {'class': 'mat-grid-avatar'}
}, ] },
];
/**
 * @nocollapse
 */
static ctorParameters: () => ({type: any, decorators?: DecoratorInvocation[]}|null)[] = () => [
];
}

function MdGridAvatarCssMatStyler_tsickle_Closure_declarations() {
/** @type {?} */
MdGridAvatarCssMatStyler.decorators;
/**
 * @nocollapse
 * @type {?}
 */
MdGridAvatarCssMatStyler.ctorParameters;
}

/**
 * Directive whose purpose is to add the mat- CSS styling to this selector.
 * \@docs-private
 */
export class MdGridTileHeaderCssMatStyler {static decorators: DecoratorInvocation[] = [
{ type: Directive, args: [{
  selector: 'md-grid-tile-header, mat-grid-tile-header',
  host: {'class': 'mat-grid-tile-header'}
}, ] },
];
/**
 * @nocollapse
 */
static ctorParameters: () => ({type: any, decorators?: DecoratorInvocation[]}|null)[] = () => [
];
}

function MdGridTileHeaderCssMatStyler_tsickle_Closure_declarations() {
/** @type {?} */
MdGridTileHeaderCssMatStyler.decorators;
/**
 * @nocollapse
 * @type {?}
 */
MdGridTileHeaderCssMatStyler.ctorParameters;
}

/**
 * Directive whose purpose is to add the mat- CSS styling to this selector.
 * \@docs-private
 */
export class MdGridTileFooterCssMatStyler {static decorators: DecoratorInvocation[] = [
{ type: Directive, args: [{
  selector: 'md-grid-tile-footer, mat-grid-tile-footer',
  host: {'class': 'mat-grid-tile-footer'}
}, ] },
];
/**
 * @nocollapse
 */
static ctorParameters: () => ({type: any, decorators?: DecoratorInvocation[]}|null)[] = () => [
];
}

function MdGridTileFooterCssMatStyler_tsickle_Closure_declarations() {
/** @type {?} */
MdGridTileFooterCssMatStyler.decorators;
/**
 * @nocollapse
 * @type {?}
 */
MdGridTileFooterCssMatStyler.ctorParameters;
}


interface DecoratorInvocation {
  type: Function;
  args?: any[];
}
